import { toastr } from "react-redux-toastr";
import { EventTypeDetails } from "../../entities/eventTypeDetails";
import { enableDisableEventTypeRequest, addEventType, getAdminEventTypes, updateAdminEventType, getAdminEventTypeDetail } from "../../services/adminEventTypeServices";
import constant from "../../util/constant";
import eventTypeConstant from "../../util/eventTypeConstant";
import {
  START_LOADER,
  STOP_LOADER,
  ADMIN_EVENT_TYPE_API_REQUEST,
  ADMIN_EVENT_TYPE_API_END,
  ADD_ADMIN_EVENT_TYPE_SUCCESS,
  ADD_ADMIN_EVENT_TYPE_FAILURE,
  GET_ADMIN_EVENT_TYPES_SUCCESS,
  GET_ADMIN_EVENT_TYPES_FAILURE,
  UPDATE_ADMIN_EVENT_TYPE_SUCCESS,
  UPDATE_ADMIN_EVENT_TYPE_FAILURE,
  GET_ADMIN_EVENT_TYPE_DETAIL_SUCCESS,
  GET_ADMIN_EVENT_TYPE_DETAIL_FAILURE,
  ENABLE_DISABLE_EVENT_TYPE_SUCCESS,
  ENABLE_DISABLE_EVENT_TYPE_FAILURE
} from "../actionTypes";

const { EVENT_TYPE_API_TYPES } = eventTypeConstant;
const { ERROR_MESSAGES } = constant;

export const addEventTypeAction = param => async ( dispatch ) => {
  try {
    dispatch( { type: START_LOADER } );
    dispatch( {
      type: ADMIN_EVENT_TYPE_API_REQUEST,
      payload: EVENT_TYPE_API_TYPES.ADD_EVENT_TYPE,
    } );

    const response = await addEventType( param );

    dispatch( { type: ADD_ADMIN_EVENT_TYPE_SUCCESS, payload: response.data } );
    dispatch( { type: STOP_LOADER } );
  }
  catch ( error ) {
    const err = Object.values( error?.data?.error || {} ) || "";

    dispatch( { type: STOP_LOADER } );
    dispatch( { type: ADD_ADMIN_EVENT_TYPE_FAILURE, payload: error } );

    if( err[ 0 ] ) {
      toastr.error( err[ 0 ] );
    }
    else {
      toastr.error( error.data.message );
    }
  }
  finally {
    dispatch( {
      type: ADMIN_EVENT_TYPE_API_END,
    } );
  }
};

export const getAdminEventTypesAction = param => async ( dispatch ) => {
  try {
    dispatch( { type: START_LOADER } );
    dispatch( {
      type: ADMIN_EVENT_TYPE_API_REQUEST,
      payload: EVENT_TYPE_API_TYPES.GET_ADMIN_EVENT_TYPES,
    } );

    const response = await getAdminEventTypes( param );
    const dataList = response.data.eventTypeData.map(
      item => new EventTypeDetails( item )
    );

    dispatch( {
      type: GET_ADMIN_EVENT_TYPES_SUCCESS,
      payload: { dataList, meta: response.data.meta },
    } );
    dispatch( { type: STOP_LOADER } );
  }
  catch ( error ) {
    dispatch( { type: STOP_LOADER } );
    dispatch( {
      type: GET_ADMIN_EVENT_TYPES_FAILURE,
      payload: error?.data?.message || ERROR_MESSAGES.EXCEPTION_ERROR,
    } );
    toastr.error( error?.data?.message || ERROR_MESSAGES.EXCEPTION_ERROR );
  }
  finally {
    dispatch( {
      type: ADMIN_EVENT_TYPE_API_END,
    } );
  }
};

export const updateAdminEventTypeAction = param => async ( dispatch ) => {
  try {
    dispatch( { type: START_LOADER } );
    dispatch( {
      type: ADMIN_EVENT_TYPE_API_REQUEST,
      payload: EVENT_TYPE_API_TYPES.UPDATE_ADMIN_EVENT_TYPE,
    } );

    const response = await updateAdminEventType( param );

    dispatch( { type: UPDATE_ADMIN_EVENT_TYPE_SUCCESS, payload: response.data } );
    dispatch( { type: STOP_LOADER } );
  }
  catch ( error ) {
    const err = Object.values( error?.data?.error || {} ) || "";

    dispatch( { type: STOP_LOADER } );
    dispatch( { type: UPDATE_ADMIN_EVENT_TYPE_FAILURE, payload: error } );

    if( err[ 0 ] ) {
      toastr.error( err[ 0 ] );
    }
    else {
      toastr.error( error.data.message );
    }
  }
  finally {
    dispatch( {
      type: ADMIN_EVENT_TYPE_API_END,
    } );
  }
};

export const getAdminEventTypeDetailAction = param => async ( dispatch ) => {
  try {
    dispatch( { type: START_LOADER } );
    dispatch( {
      type: ADMIN_EVENT_TYPE_API_REQUEST,
      payload: EVENT_TYPE_API_TYPES.GET_ADMIN_EVENT_TYPE_DETAIL,
    } );

    const response = await getAdminEventTypeDetail( param );
    const newResponse = new EventTypeDetails( response.data );

    dispatch( {
      type: GET_ADMIN_EVENT_TYPE_DETAIL_SUCCESS,
      payload: newResponse,
    } );
    dispatch( { type: STOP_LOADER } );
  }
  catch ( error ) {
    dispatch( { type: STOP_LOADER } );
    dispatch( {
      type: GET_ADMIN_EVENT_TYPE_DETAIL_FAILURE,
      payload: error?.data?.message || ERROR_MESSAGES.EXCEPTION_ERROR,
    } );
    toastr.error( error?.data?.message || ERROR_MESSAGES.EXCEPTION_ERROR );
  }
  finally {
    dispatch( {
      type: ADMIN_EVENT_TYPE_API_END,
    } );
  }
};

export const enableDisableEventTypeAction = requestObj => async ( dispatch ) => {
  try {
    dispatch( { type: START_LOADER } );
    dispatch( {
      type: ADMIN_EVENT_TYPE_API_REQUEST,
      payload: EVENT_TYPE_API_TYPES.ENABLE_DISABLE_PARTNER_GAME,
    } );

    const response = await enableDisableEventTypeRequest( requestObj );

    dispatch( { type: ENABLE_DISABLE_EVENT_TYPE_SUCCESS, payload: response } );
    dispatch( { type: STOP_LOADER } );
  }
  catch ( error ) {
    dispatch( { type: ENABLE_DISABLE_EVENT_TYPE_FAILURE, payload: error } );
    dispatch( { type: STOP_LOADER } );
    toastr.error( error?.error || constant.ERROR_MESSAGES.EXCEPTION_ERROR );
  }
  finally {
    dispatch( { type: ADMIN_EVENT_TYPE_API_END } );
  }
};
